<div class="form-group mb-3">
  @if (label) {
    <div class="d-flex justify-content-between align-items-baseline mb-2">
      <label class="form-label mb-0">
        {{ label }}
        <span *ngIf="required" class="text-danger">*</span>
      </label>
      @if (showForgotPassword) {
        <a routerLink="/forgot-password" class="text-decoration-none">
          Forgot Password?
        </a>
      }
    </div>
  }

  <div class="input-group">
    <input
      [type]="showPassword ? 'text' : 'password'"
      class="form-control"
      [class.is-invalid]="errorMessage"
      [placeholder]="placeholder"
      [required]="required"
      [disabled]="disabled"
      [value]="value"
      (input)="onInputChange($event)"
      (blur)="onInputBlur()"
    />
    <button
      class="btn btn-outline-secondary"
      type="button"
      tabindex="-1"
      (click)="togglePasswordVisibility()"
      [disabled]="disabled"
    >
      <i [class]="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
    </button>
  </div>

  <div *ngIf="errorMessage" class="invalid-feedback d-block">
    {{ errorMessage }}
  </div>

  <!-- Password Requirements Checklist -->
  <div *ngIf="showRequirements && value.length > 0" class="password-requirements mt-2">
    <small class="text-muted d-block mb-1">Password must contain:</small>
    <ul class="list-unstyled mb-0">
      <li [class.text-success]="requirements.minLength" [class.text-muted]="!requirements.minLength">
        <i [class]="requirements.minLength ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
        At least 8 characters
      </li>
      <li [class.text-success]="requirements.hasUpperCase" [class.text-muted]="!requirements.hasUpperCase">
        <i [class]="requirements.hasUpperCase ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
        One uppercase letter
      </li>
      <li [class.text-success]="requirements.hasLowerCase" [class.text-muted]="!requirements.hasLowerCase">
        <i [class]="requirements.hasLowerCase ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
        One lowercase letter
      </li>
      <li [class.text-success]="requirements.hasNumber" [class.text-muted]="!requirements.hasNumber">
        <i [class]="requirements.hasNumber ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
        One number
      </li>
      <li [class.text-success]="requirements.hasSpecialChar" [class.text-muted]="!requirements.hasSpecialChar">
        <i [class]="requirements.hasSpecialChar ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
        One special character
      </li>
    </ul>
  </div>
</div>
